var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-header',{attrs:{"color":"nm-gradient-1","firstLine":"Games for","secondLine":"Brand","keyword":"Relevance","tagline":"Manage your Marketing Campaigns in exciting new ways for a lasting impression. Check out our portfolio!","buttonLink":"portfolio","buttonText":"Portfolio"}}),_c('panel',{attrs:{"color":"nm-gradient-2","title":"ATTENTION IS VALUABLE","subtitle":"And as game developers, we understand this better than most. Seconds of distraction can lead to disengagement. How do we stay relevant?","text":"Our games are easy to learn, hard to master, and made for all ages.","cards":[
      {
        icon:'play',
        title:'Play',
        text:'Addictive, intuitive casual games that are beautifully crafted by our experts, and market-tested for long-term engagement.'
      },
      {
        icon:'win',
        title:'Win',
        text:'Real rewards, exclusive deals, shareable gifts and a whole lot of enjoyment.'
      },
      {
        icon:'repeat',
        title:'Repeat',
        text:'Habit-forming activities strengthens brand relevance, and creates a personal way to interact with your audience.'
      } ]}}),_c('panel',{attrs:{"alt":"","color":"nm-gradient-3","title":"ORCHESTRATE YOUR CAMPAIGN","subtitle":"Make changes on the fly with our tools. Track their focus and attention. Customise rewards and see how they respond through our Realtime Analytics. Encourage sharing, send notifications straight to their pocket.","text":"Build your community today.","cards":[
      {
        icon:'cross_platform',
        title:'Cross Platform',
        text:'Build for iOS, Android, and Web.'
      },
      {
        icon:'campaign_management',
        title:'Campaign Management',
        text:'Design unique experiences.'
      },
      {
        icon:'reward_management',
        title:'Reward Management',
        text:'Customise your gifts.'
      },
      {
        icon:'player_management',
        title:'Player Management',
        text:'Get to know your fanbase.'
      },
      {
        icon:'realtime_analytics',
        title:'Realtime Analytics',
        text:'Data never lies.'
      },
      {
        icon:'leaderboards',
        title:'Leaderboards',
        text:'For a healthy competition.'
      },
      {
        icon:'social_sharing',
        title:'Social Sharing',
        text:'Go Viral!'
      },
      {
        icon:'remote_notifications',
        title:'Remote Notifications',
        text:'Send them a text!'
      },
      {
        icon:'in-game_promotions',
        title:'In-Game Promotions',
        text:'Highlight your special of the day.'
      }
    ]}}),_c('page-footer',{attrs:{"color":"nm-gradient-4","buttonLink":"portfolio","buttonText":"Portfolio","text":"Check out how we've given brands a new tool in marketing."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }